import { TFunction } from 'i18next';
import isSameDay from 'date-fns/isSameDay';
import startCase from 'lodash/startCase';

import {
  defaultDateFormat,
  formatDate,
  formatTime,
} from 'approot/shared/logic/dates';
import {
  CONTENT_TYPE_LABELS,
  INTRODUCTION_SLIDE_NUMBER,
  CONCLUSION_SLIDE_NUMBER,
} from 'global/constants';

export type GroupedData<T extends { date: Date }> = {
  [key: string]: T[];
};

export function groupData<T extends { date: Date }>(
  versions: T[],
  t: TFunction
) {
  const today = new Date();

  const groups: { [key: string]: T[] } = {
    Today: [],
  };

  for (let i = 0; i < versions.length; i++) {
    const itemDate = new Date(versions[i].date);
    if (isSameDay(today, itemDate)) {
      groups.Today.push(versions[i]);
    } else {
      const dateString = defaultDateFormat(itemDate, t);
      if (!groups[dateString]) {
        groups[dateString] = [versions[i]];
      } else {
        groups[dateString].push(versions[i]);
      }
    }
  }

  return groups;
}

export function restoredAtMessage(date: Date) {
  const updatedAtDate = formatDateOrToday(new Date(date));
  return `Restored Draft from ${updatedAtDate}, ${formatTime(new Date(date))}`;
}

export function formatDateOrToday(date: string | Date): string {
  // if the date is today, return 'Today'
  const parsedDate = typeof date === 'string' ? new Date(date) : date;
  const currentYear = new Date().getFullYear();
  if (isSameDay(new Date(), parsedDate)) {
    new Date(parsedDate);
    return 'Today';
  }
  // hide the year if it's the current year
  const optionalYearFormatString =
    parsedDate.getFullYear() === currentYear ? 'MMMM d' : 'MMMM d, yyyy';
  return formatDate(parsedDate, optionalYearFormatString);
}

export function getSlideEventLabel(
  slideNumber: number | null,
  subSlideNumber: number | null
) {
  if (slideNumber === null) return 'Global';
  if (slideNumber === INTRODUCTION_SLIDE_NUMBER) {
    return 'Introduction';
  }

  if (slideNumber === CONCLUSION_SLIDE_NUMBER) {
    return 'Conclusion';
  }

  return subSlideNumber
    ? `Activity ${slideNumber} - Sub-activity ${subSlideNumber}`
    : `Activity ${slideNumber}`;
}

export function getComponentTypeLabel(componentType: string) {
  const foundType = CONTENT_TYPE_LABELS.find(
    type => type.value === componentType
  );
  return foundType ? foundType.label : startCase(componentType);
}
